// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout alinhado ao protótipo definicao/esocial-tributacoes.txt */

.styles_page__MUBZU {
  background: #fff;
  margin: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 28px 32px 32px;
  box-sizing: border-box;
}

.styles_pageHeader__5PSXC {
  margin-bottom: 28px;
}

.styles_pageTitle__sZzEn {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 26px;
  font-weight: 700;
  color: #0d2847;
  margin: 0;
}

.styles_pageTitleIcon__Z8HJu {
  font-size: 28px !important;
  color: #0d2847;
}

.styles_pageSubtitle__Pf3Ln {
  margin: 8px 0 0;
  font-size: 14px;
  color: #666;
  font-weight: 400;
}

.styles_configSection__A-Ftm {
  border: 1px solid #e8eef3;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
}

.styles_configSectionHeader__rO3qQ {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  background: #f8f9fa;
  border-bottom: 1px solid #e8eef3;
}

.styles_configSectionIcon__RHrym {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #e3f2fd;
  color: #1565c0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.styles_configSectionIconSvg__qy40R {
  font-size: 22px !important;
}

.styles_configSectionHeader__rO3qQ h2 {
  font-size: 18px;
  font-weight: 600;
  color: #0d2847;
  margin: 0;
}

.styles_configSectionHeader__rO3qQ p {
  font-size: 13px;
  color: #666;
  margin: 2px 0 0;
}

.styles_configSectionBody__\\+vJpM {
  padding: 22px;
}

.styles_varsIntro__cOZhF {
  font-size: 13px;
  color: #666;
  margin: 0 0 20px;
}

.styles_varsGrid__GlTa7 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 24px;
}

@media (max-width: 720px) {
  .styles_varsGrid__GlTa7 {
    grid-template-columns: 1fr;
  }
}

.styles_formField__-vsJJ label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #0d2847;
  margin-bottom: 6px;
}

.styles_formField__-vsJJ input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #333;
  box-sizing: border-box;
}

.styles_formField__-vsJJ input:focus {
  outline: 2px solid #90caf9;
  outline-offset: 1px;
  border-color: #90caf9;
}

.styles_formField__-vsJJ input:disabled {
  background: #f5f5f5;
  color: #666;
}

.styles_formHint__ld8ZI {
  margin-top: 6px;
  font-size: 12px;
  color: #888;
}

.styles_formActions__Xmu0n {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.styles_btnSalvar__syf6G {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1e4a7a;
  color: #fff;
  border: none;
  padding: 10px 22px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.styles_btnSalvar__syf6G:hover {
  background: #163a62;
}

.styles_btnSalvar__syf6G:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.styles_btnSalvarIcon__rbOhN {
  font-size: 20px !important;
}

.styles_erro__Z2XfY {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #fdecea;
  color: #b71c1c;
  font-size: 14px;
  margin-bottom: 16px;
}

.styles_btnRetry__gP0m1 {
  background: #fff;
  color: #b71c1c;
  border: 1px solid #e57373;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.styles_btnRetry__gP0m1:hover {
  background: #fff5f5;
}

.styles_loadingInline__JKe\\+J {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Tributarias/styles.module.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb","sourcesContent":["/* Layout alinhado ao protótipo definicao/esocial-tributacoes.txt */\n\n.page {\n  background: #fff;\n  margin: 16px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  padding: 28px 32px 32px;\n  box-sizing: border-box;\n}\n\n.pageHeader {\n  margin-bottom: 28px;\n}\n\n.pageTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n  font-size: 26px;\n  font-weight: 700;\n  color: #0d2847;\n  margin: 0;\n}\n\n.pageTitleIcon {\n  font-size: 28px !important;\n  color: #0d2847;\n}\n\n.pageSubtitle {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #666;\n  font-weight: 400;\n}\n\n.configSection {\n  border: 1px solid #e8eef3;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\n.configSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 22px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e8eef3;\n}\n\n.configSectionIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #e3f2fd;\n  color: #1565c0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.configSectionIconSvg {\n  font-size: 22px !important;\n}\n\n.configSectionHeader h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0d2847;\n  margin: 0;\n}\n\n.configSectionHeader p {\n  font-size: 13px;\n  color: #666;\n  margin: 2px 0 0;\n}\n\n.configSectionBody {\n  padding: 22px;\n}\n\n.varsIntro {\n  font-size: 13px;\n  color: #666;\n  margin: 0 0 20px;\n}\n\n.varsGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px 24px;\n}\n\n@media (max-width: 720px) {\n  .varsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.formField label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0d2847;\n  margin-bottom: 6px;\n}\n\n.formField input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #cfd8dc;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #333;\n  box-sizing: border-box;\n}\n\n.formField input:focus {\n  outline: 2px solid #90caf9;\n  outline-offset: 1px;\n  border-color: #90caf9;\n}\n\n.formField input:disabled {\n  background: #f5f5f5;\n  color: #666;\n}\n\n.formHint {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #888;\n}\n\n.formActions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.btnSalvar {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #1e4a7a;\n  color: #fff;\n  border: none;\n  padding: 10px 22px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnSalvar:hover {\n  background: #163a62;\n}\n\n.btnSalvar:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btnSalvarIcon {\n  font-size: 20px !important;\n}\n\n.erro {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 6px;\n  background: #fdecea;\n  color: #b71c1c;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.btnRetry {\n  background: #fff;\n  color: #b71c1c;\n  border: 1px solid #e57373;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnRetry:hover {\n  background: #fff5f5;\n}\n\n.loadingInline {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__MUBZU`,
	"pageHeader": `styles_pageHeader__5PSXC`,
	"pageTitle": `styles_pageTitle__sZzEn`,
	"pageTitleIcon": `styles_pageTitleIcon__Z8HJu`,
	"pageSubtitle": `styles_pageSubtitle__Pf3Ln`,
	"configSection": `styles_configSection__A-Ftm`,
	"configSectionHeader": `styles_configSectionHeader__rO3qQ`,
	"configSectionIcon": `styles_configSectionIcon__RHrym`,
	"configSectionIconSvg": `styles_configSectionIconSvg__qy40R`,
	"configSectionBody": `styles_configSectionBody__+vJpM`,
	"varsIntro": `styles_varsIntro__cOZhF`,
	"varsGrid": `styles_varsGrid__GlTa7`,
	"formField": `styles_formField__-vsJJ`,
	"formHint": `styles_formHint__ld8ZI`,
	"formActions": `styles_formActions__Xmu0n`,
	"btnSalvar": `styles_btnSalvar__syf6G`,
	"btnSalvarIcon": `styles_btnSalvarIcon__rbOhN`,
	"erro": `styles_erro__Z2XfY`,
	"btnRetry": `styles_btnRetry__gP0m1`,
	"loadingInline": `styles_loadingInline__JKe+J`
};
export default ___CSS_LOADER_EXPORT___;
